import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { OrdinalDateAdapter, OrdinalDateParse, ORD_DATE_FORMATS } from '../../../adapters/ordinal-date-adapter';
import { DataIdName } from '../../../entities/global/model';
import { GETInventoryService } from '../../../services/inventory.service';
import { AddRepairerWorkshopModalComponent } from '../../../add-repairer-workshop-modal/add-repairer-workshop-modal.component';
import { ErrorCode, ErrorMessages } from '../../../entities/global/error-codes';
import { ImplementCycleDetails, ImplementRebuildCompleteVM, RebuildImplementVM } from '../../../add-observation-point/add-observation-point-modal';
import { ImplementDetailsService } from '../../../implement-details/implement-details.service';
import { NotificationsService } from 'angular2-notifications';
import { ComponentVM, GenericIdName } from '../../../setup-implement/setup-implement.model';
import { ComponentRepairData } from '../../../entities/component/model';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-implement-rebuild-dialog',
  templateUrl: './implement-rebuild-dialog.component.html',
  styleUrls: ['./implement-rebuild-dialog.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class ImplementRebuildDialogComponent implements OnInit {
  selectedTab:number=0;
  implementId:number
  implementName:string
  customerID:number
  jobsiteId:number;
  jobsiteName:string
  statusList: DataIdName[];
  status:string
  statusID:number
  repairerList: DataIdName[];
  workshopList:DataIdName[];
  selectedRepairerId: number = 0;
  selectedWorkshopId: number = 0;
  showAddWorkshop: boolean = true;
  cost:number;
  comment:string
  eventDate: Date = new Date();
  savingChanges:boolean=false;


  //rebuild complete varibled

  //implementId:number
  //implementName:string
  //customerID:number
  //jobsiteId:number;
  //jobsiteName:string;
  rebuildCompleteventDate: Date = new Date();
  startDate:Date;
  CycleDetails:ImplementCycleDetails;
  cycleNo:number=0;
  hours:number;
  bcm:number;
  tons:number;
  rebuildCompletcomment:string;
  rebuildCompletesavingChanges:boolean=false;


    // Tooltips
    ttDate: string = "Click here to select a date.";
    ttComment: string = "You may enter a maximum of 256 characters.";





    ///component action  vcaribles
    ord: OrdinalDateParse = new OrdinalDateParse();

    //jobsiteId: number;
    //jobsiteName: string;
    equipmentId: number=0;
    customerId: number;
  
    implementList: GenericIdName[] = [];
    componentList: ComponentVM[] = [];
    CopycomponentList: ComponentVM[] = [];
  
    componentTypes: GenericIdName[] = [];
  
    selectedImplement: number;
    selectedComponent: number;
    selectedComponentType: number[];
  
  
    currentSmu: number;
    ActioneventDate: Date = new Date();
 
    actionType: number = 1;
    recordRepairData: ComponentRepairData;
    recordReplaceData: ComponentRepairData;
    CompActionsavingChanges: boolean = false;
  
    // Toggle
    minDateForAction: Date = new Date();
    maxDateForAction: Date = new Date();
  
    // Replace
    minDate1: Date = new Date();
    maxDate1: Date = new Date();
  
    // Repair
    minDate2: Date = new Date();
    maxDate2: Date = new Date();

  
    cbAllComponentSelect:boolean=false;
    downtimeHrs: number=0;
    DisabledSaveButton:boolean=false;
    StartRebuildDisabledSaveButton:boolean=false;



    TLabour_Hours:number=0;
    TLabour_Cost:number=0;
    TPart_Cost:number=0;
    TMisc_Cost:number=0;
    TTotal_Cost:number=0;

    DLabour_Hours:number;
    DLabour_Cost:number;
    DPart_Cost:number;
    DMisc_Cost:number;
    DTotal_Cost:number;

    //end component action
  constructor(private dialogRef: MatDialogRef<ImplementRebuildDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _inventoryService: GETInventoryService,
    public addRepairerWorkshopModal: MatDialog,
    public _implementService: ImplementDetailsService, 
    public _setupimplementService: SetupImplementService,
    public toastr: NotificationsService, vcr: ViewContainerRef) {

    }

  ngOnInit() {

    if(this.data != null){
      this.implementId=this.data.implementId;
      this.selectedImplement = this.data.implementId;
      this.customerID=this.data.customerId;
      this.customerId = this.data.customerId;
      this.implementName =this.data.implementName;
      this.jobsiteId=this.data.jobsiteId;
      this.jobsiteName=this.data.jobsiteName;
     
    }
    this.getCycleDetails();
    this.comment="";
    this.rebuildCompletcomment=""
    this.getInventoryStatus();
    this.reloadRepairerListForCustomer();
    
 
  }

  LoadData(index:number){

    if(index==1)//Component Action
    {
    if(this.implementId>0){
      this.recordReplaceData = new ComponentRepairData();
      this.recordRepairData = new ComponentRepairData();
      this.recordRepairData.cost = 0;
      this.recordReplaceData.cost = 0;
      this.recordRepairData.comment = "";
      this.recordReplaceData.comment = "";
      this.eventDate = new Date();
      this.recordReplaceData.date = this.eventDate;
      this.recordRepairData.date = this.eventDate;
      this.ActioneventDate = this.startDate!=null?this.startDate:this.ActioneventDate;
      this.implementSelected();
    }
    }
  }



  //Compoent action tab _-----------------------------------------------------------------------------------------

  implementSelected() {
    //this.selectedImplement = v;
    this.loadComponentTypes();
    this._setupimplementService.ReturnGETComponents(this.selectedImplement).subscribe(result => {
        this.componentList = result;
        this.CopycomponentList = result;
    });
}

//Component Type For Implements
loadComponentTypes() {
    this._setupimplementService.GetMasterComponentTypeList(this.selectedImplement).subscribe(r => {
      this.componentTypes = r;
      console.log("this.componentTypes,", this.componentTypes);
    });
}

doReplace() {
  this.minDateForAction = this.minDate1;
  this.maxDateForAction = this.maxDate1;
}

doRepair() {
  this.minDateForAction = this.minDate1;
  this.maxDateForAction = this.maxDate2;
}

toggleAllObsevations(v) {
  console.log("Select All",v)
  //this.componentList.forEach(c => c.selectComp = v);
     this.componentList.forEach(c => {
    c.selectComp = v;
    c.Planned = v;
  });
  if(v==true){
      this.componentList.map(x=>{
      
          this._inventoryService.returnMinDateForComponentReplace(x.Id.toString())
          .subscribe(response => {
              if (response != "") {
                  try {
                      this.minDate1 = new Date(response);
                      if(this.ActioneventDate< this.minDate1){
                         // console.log("this.action__", this.minDate1, this.eventDate)
  
                          x.ActionSucess=-1;
                          x.ActionMinDate=this.minDate1;
                          x.Error="Action date should be greater than ";
                          this.DisabledSaveButton=true;
                          return;
                      }else{
                          x.ActionSucess=0;
                          x.ActionMinDate=null;
                          x.Error="";
                      }
                  }
                  catch (ex) {
                      this.minDate1 = new Date();
                  } finally {
                         // this.minDateForAction = this.minDate1;
                  }
              }
  
  
          });
      })
  }
  
 
}

arr_ReplaceComponents: ComponentVM[];
arr_RepaprComponents: ComponentVM[];

validateData_New():number{
  var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
      returnCode = ErrorCode.VALIDATION_PASSED;
 
  return returnCode;
}

saveChangesNewAction() {
  if (this.CompActionsavingChanges) {
      return;
  }

  let validation = this.validateData_New();
  this.CompActionsavingChanges = true;


  if (validation == ErrorCode.VALIDATION_PASSED) {
      if (this.componentList.find(x => x.selectComp == true)) {
         

              this.arr_ReplaceComponents = this.componentList.filter(x => x.selectComp == true && x.ActionId == 1);
                      this.arr_RepaprComponents = this.componentList.filter(x => x.selectComp == true && x.ActionId == 2);

                      const compReplaceRes = this.arr_ReplaceComponents.map(async x => {

                          let replace = new ComponentRepairData();
                          replace.componentId = x.Id;
                          replace.cost = x.cost==null?0:x.cost;
                          replace.comment = x.comment!=null?x.comment:"";
                          replace.date = new Date(this.startDate);
                          replace.downTimeHrs = this.downtimeHrs!=null?this.downtimeHrs:0;
                          replace.smu = 0;
                          replace.labourHrs = x.LabourHrs;
                          replace.labourCost = x.LabourCost;
                          replace.parts = x.PartCost;
                          replace.misc = x.MiscCost;
                          replace.planned = x.Planned;
                          replace.equipmentId= 0;
                          console.log("recordReplaceData1", replace)
                          const response = await this._inventoryService.replaceComponent(replace).toPromise();
                          if (response == false) {
                              x.ActionSucess = 2;
                              this.CompActionsavingChanges = false;
                              console.log("ErrorPerformAction", x.ActionSucess)
                          } else if (response == true) {
                              x.ActionSucess = 1;
                              console.log("PerformAction", x.ActionSucess)
                          }
                          return response;


                      });
                      Promise.all(compReplaceRes).then(repairComp => {
                          const compRepaireRes = this.arr_RepaprComponents.map(async x => {

                              let replace = new ComponentRepairData();
                              replace.componentId = x.Id;
                              replace.cost = x.cost!=null?x.cost:0;
                              replace.comment = x.comment!=null?x.comment:"";
                              replace.date = this.ActioneventDate;
                              replace.downTimeHrs = this.downtimeHrs!=null?this.downtimeHrs:0;
                              replace.smu = 0;
                              replace.labourHrs = x.LabourHrs;
                              replace.labourCost = x.LabourCost;
                              replace.parts = x.PartCost;
                              replace.misc = x.MiscCost;
                              replace.planned = x.Planned;
                               replace.equipmentId= 0;
                              console.log("recordRepaireData1", replace)
                              const response = await this._inventoryService.repairComponent(replace).toPromise();
                              if (response == false) {
                                  x.ActionSucess = 2;
                                  this.CompActionsavingChanges = false;
                                  console.log("ErrorPerformAction", x.ActionSucess)
                              } else if (response == true) {
                                  x.ActionSucess = 1;
                                  console.log("PerformAction", x.ActionSucess)
                              }
                              return response;


                          });

                          Promise.all(compRepaireRes).then(repairComp => {
                             // this.dialogRef.close();\
                             this.toastr.success("Sucessfully Saved Component repiar and Replace Action")
                             this.selectedTab=2;
                          })
                      });
          
      }
  }
  


}

ChangecomponentType() {

  let arr = [];
  this.componentList = this.CopycomponentList;
  console.log("componentlist", this.componentList)
  if (this.selectedComponentType.length > 0) {
      this.selectedComponentType.map(x => {

          this.componentList.map(c=>{
              if(c.CompTypeId==x){
                  if (arr.length == 0) {
                      arr.push(c);
                  } else {
                      let info = arr.find(y => y.Id == c.Id);
                      if (info == null) {
                          arr.push(c);
                      }
                  }
              }
          })
          //let data_ = this.componentList.find(c => c.CompTypeId == x);


         

      })
      this.componentList = arr;
  }else{
      this.componentList = [];
  }

}


componentSelected(v) {
  this.selectedComponent = v;
  this.recordRepairData.componentId = this.selectedComponent;
  this.recordReplaceData.componentId = this.selectedComponent;

  this._inventoryService.returnMinDateForComponentReplace(this.selectedComponent.toString())
      .subscribe(response => {
          if (response != "") {
              try {
                  this.minDate1 = new Date(response);
              }
              catch (ex) {
                  this.minDate1 = new Date();
              } finally {
                      this.minDateForAction = this.minDate1;
              }
          }
      });


}

//SMU
smuChange(): void {
  this.recordReplaceData.smu = this.currentSmu;
  this.recordRepairData.smu = this.currentSmu;
}

// Cost
costChanged(): void {
  this.recordReplaceData.cost = this.cost != null ? this.cost : 0;
  this.recordRepairData.cost = this.cost != null ? this.cost : 0;
}

// Date
dateChanged(): void {
  this.recordReplaceData.date = this.eventDate;
  this.recordRepairData.date = this.eventDate;
  this.ord.formatDateOrdinal((this.eventDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);

      this.componentList.map(x=>{
          if(x.selectComp==true && x.ActionSucess==-1){
              x.selectComp=false;
              this.DisabledSaveButton=false;
          }
      })
}

//DownTimeHrs
downtimeHrsChanged() {
  this.recordReplaceData.downTimeHrs = this.downtimeHrs;
}

// Comment
commentChanged(): void {
  this.recordReplaceData.comment = this.comment;
  this.recordRepairData.comment = this.comment;
}


//new code
onComponentListControlChanged(id, name,comp:ComponentVM) {
  let selectedComp_ = this.componentList.find(x => x.Id == id);
  if(selectedComp_.selectComp==true){
      selectedComp_.selectComp = false;
      this.hasChecked=true;
      selectedComp_.Planned = false;
  }else{
      selectedComp_.selectComp = true;
      this.hasChecked=false;
      selectedComp_.Planned = true;
      //this.componentSelected(id);
      this._inventoryService.returnMinDateForComponentReplace(id.toString())
      .subscribe(response => {
          if (response != "") {
              try {
                  this.minDate1 = new Date(response);
                  if(this.eventDate< this.minDate1){
                     // console.log("this.action__", this.minDate1, this.eventDate)
                      comp.ActionSucess=-1;
                      comp.ActionMinDate=this.minDate1;
                      comp.Error="Action date should be greater than ";
                      this.DisabledSaveButton=true;
                      return;
                  }else{
                      comp.ActionSucess=0;
                      comp.ActionMinDate=null;
                      comp.Error="";
                  }
              }
              catch (ex) {
                  this.minDate1 = new Date();
              } finally {
                     // this.minDateForAction = this.minDate1;
              }
          }


      });


  }
  this.totalcost = 0;
      this.totalLabour=0;
      this.totalMisc=0;
      this.totalparts=0;
      this.totalHrs=0;
      this.componentList.map(x=>{
        if(x.selectComp==true) {
         // this.totalcost = this.totalcost + x.cost;
          this.totalLabour = this.totalLabour + x.LabourCost;
          this.totalMisc = this.totalMisc + x.MiscCost;
          this.totalparts = this.totalparts + x.PartCost;
          this.totalcost =   this.totalLabour+ this.totalMisc+this.totalparts;
          this.totalHrs = this.totalHrs + x.LabourHrs;

          this.calculateDifferenceLabourCost();
      this.calculateDifferencePartCost();
      this.calculateDifferenceMiscCost();
      this.calculateDifferenceLabourHours();
        } 
      })

 
}


totalHrs:number=0;
totalLabour:number=0;
totalparts:number=0;
totalMisc:number=0;
totalcost:number=0;
hasChecked:boolean=true;

hasDiffernce:boolean=false;
calculateDifferenceLabourHours(){
  this.DLabour_Hours = this.TLabour_Hours>0 ?this.TLabour_Hours - this.totalHrs:0;
  console.log("TLabour_Hours", this.TLabour_Hours,this.totalHrs)
  if(this.DLabour_Hours!=0 || this.DLabour_Cost!=0 || this.DPart_Cost!=0 ||this.DMisc_Cost!=0){
    this.hasDiffernce=true;
  }else{
    this.hasDiffernce=false;
  }

}
calculateDifferenceLabourCost(){
  this.DLabour_Cost = this.TLabour_Cost>0 ?this.TLabour_Cost - this.totalLabour:0;
  this.TTotal_Cost =  this.DLabour_Cost +  this.DPart_Cost + this.DMisc_Cost;
  this.calculateDifferenceTotalCost();

  console.log("TLabour_Cost", this.TLabour_Cost,this.totalLabour,this.DLabour_Cost)
  if(this.DLabour_Hours!=0 || this.DLabour_Cost!=0 || this.DPart_Cost!=0 ||this.DMisc_Cost!=0){
    this.hasDiffernce=true;
  }else{
    this.hasDiffernce=false;
  }
}
calculateDifferencePartCost(){
  this.DPart_Cost = this.TPart_Cost>0 ?this.TPart_Cost - this.totalparts:0;
   this.TTotal_Cost =  this.DLabour_Cost +  this.DPart_Cost + this.DMisc_Cost;
  this.calculateDifferenceTotalCost();
  if(this.DLabour_Hours!=0 || this.DLabour_Cost!=0 || this.DPart_Cost!=0 ||this.DMisc_Cost!=0){
    this.hasDiffernce=true;
  }else{
    this.hasDiffernce=false;
  }
}
calculateDifferenceMiscCost(){
  this.DMisc_Cost = this.TMisc_Cost>0 ?this.TMisc_Cost - this.totalMisc:0;
  this.TTotal_Cost =  this.DLabour_Cost +  this.DPart_Cost + this.DMisc_Cost;
  this.calculateDifferenceTotalCost();
  if(this.DLabour_Hours!=0 || this.DLabour_Cost!=0 || this.DPart_Cost!=0 ||this.DMisc_Cost!=0){
    this.hasDiffernce=true;
  }else{
    this.hasDiffernce=false;
  }
}
calculateDifferenceTotalCost(){
  this.DTotal_Cost = this.TTotal_Cost>0 ?this.TTotal_Cost - this.totalcost:0;
}

calculateTotalCost(comp:ComponentVM){
  comp.cost = comp.PartCost + comp.MiscCost+ comp.LabourCost;
  this.totalcost = 0;
  this.totalLabour=0;
  this.totalMisc=0;
  this.totalparts=0;
console.log("list__", this.componentList)
  this.componentList.map(x=>{
    if(x.selectComp==true) {
     // this.totalcost = this.totalcost + x.cost;
      this.totalLabour = this.totalLabour + x.LabourCost;
      this.totalMisc = this.totalMisc + x.MiscCost;
      this.totalparts = this.totalparts + x.PartCost;
      this.totalcost =   this.totalLabour+ this.totalMisc+this.totalparts;

     
      this.calculateDifferenceLabourCost();
      this.calculateDifferencePartCost();
      this.calculateDifferenceMiscCost();

    } 
  })
}

calculateTotalHrs(comp:ComponentVM){
  
  this.totalHrs = 0;
  this.componentList.map(x=>{
    if(x.selectComp==true) {
      this.totalHrs = this.totalHrs + x.LabourHrs;
      this.calculateDifferenceLabourHours();
    } 
  })
}

  //end Componet Action Tab End code ---------------------------------------------------------------------------

  //rebuild complete tab data__________________------------------------------------------------------------------------------------------
  getCycleDetails(){
    this._implementService.GetCurrentCycleDetails(this.implementId).subscribe(response=>{
      console.log(response)
      this.CycleDetails=response;
      this.startDate = this.CycleDetails.EndDate;
      this.cycleNo=this.CycleDetails.CycleNo;
      //this.eventDate=this.startDate
      this.tons=this.CycleDetails.Tons;
      this.bcm=this.CycleDetails.BCM;
      this.hours=this.CycleDetails.Hours;
      if(this.startDate!=null){
        console.log("dsadad",this.startDate,this.selectedTab)
        this.selectedTab=1;
        this.StartRebuildDisabledSaveButton=true;
        this.implementSelected();
      }else{
        this.selectedTab=0;
        this.StartRebuildDisabledSaveButton=false;

      }
    })
    
    
  }


  saveChangesRebuildComplete(){
    if (this.rebuildCompletesavingChanges) {
      return;
  }

  let validation = this.validateDataRebuildComplete();
  this.rebuildCompletesavingChanges = true;
  if (validation == ErrorCode.VALIDATION_PASSED) {
    var params: ImplementRebuildCompleteVM = new ImplementRebuildCompleteVM();
        params.ImplementId = this.implementId;
        params.StartDate = this.rebuildCompleteventDate;
        params.comment=this.rebuildCompletcomment==null?"":this.rebuildCompletcomment;
        params.Hours=this.hours;
        params.BCM=this.bcm;
        params.Tons=this.tons;
        params.jobsiteID=this.jobsiteId;
        params.CycleNo=this.cycleNo+1;
        console.log("params",params)
    this._implementService.SaveRebuildComplete(params).subscribe(response=>{
      console.log("response", response)
      if(response){
        this.dialogRef.close();
        this.toastr.success("Sucessfully Completed Asset Rebuild")
      }
    })
  }else{
    this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
    this.rebuildCompletesavingChanges = false;
  }
  }

  validateDataRebuildComplete(): number {
    var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
        if (this.implementId
            && this.hours >=0
            && this.bcm >=0
            && this.tons >=0
            && this.startDate) {
              returnCode = ErrorCode.VALIDATION_PASSED;
        }
    return returnCode;
  }
  // Rebuild Tab End Code--------------------------------------------------------------------------------------------

  getInventoryStatus(){
    this._inventoryService.returnInventoryStatusList().subscribe(response => {
      this.statusList = response;
      this.statusList= this.statusList.filter(x=>x.Id ==6)
      this.statusID = this.statusList[0].Id;
      this.status=this.statusList[0].Name;
    }, error => { console.log(error); });
  }

  reloadRepairerListForCustomer() {
    if (this.data.jobsiteId != null) {
      this._inventoryService.returnRepairerListForCustomer(this.data.jobsiteId).subscribe(response => {
        this.repairerList = response;

        if (this.selectedRepairerId != 0) {
          this.repairerSelected(this.selectedRepairerId);
        }
      }, error => { console.log(error); });
    }
  }

   // Repairer
   repairerSelected(repairerId): void {
    this.selectedRepairerId = repairerId;

    this._inventoryService.returnWorkshopListForRepairer(repairerId).subscribe(response => {
      this.workshopList = response;
      this.showAddWorkshop = true;

      if (this.selectedWorkshopId != 0) {
        this.workshopSelected(this.selectedWorkshopId);
      }
    }, error => { console.log(error); });
  }

   // Workshop
   workshopSelected(workshopId): void {
    this.selectedWorkshopId = workshopId;
  }


  // Add repairer and workshop
  addRepairer(): void {
    this._inventoryService.setRepairerId(0);
    let addRepairerWorkshopModalRef = this.addRepairerWorkshopModal.open(AddRepairerWorkshopModalComponent, {
      width: '550px',
      data: {
        jobsiteId: this.jobsiteId,
        jobsiteName: this.jobsiteName
      }
    });
    addRepairerWorkshopModalRef.afterClosed().subscribe(() => {
      this.reloadRepairerListForCustomer();
      this.selectedRepairerId = this._inventoryService.getRepairerId();
      console.log( this.selectedRepairerId,"repairerID")
    });
  }
  addWorkshop(): void {
    console.log( this.selectedRepairerId,"repairerID")
    this._inventoryService.setWorkshopId(0);
    let addRepairerWorkshopModalRef = this.addRepairerWorkshopModal.open(AddRepairerWorkshopModalComponent, {
      width: '550px',
      data: {
        jobsiteId: this.jobsiteId,
        jobsiteName: this.jobsiteName,
        repairerId: this.selectedRepairerId
      }
    });
    addRepairerWorkshopModalRef.afterClosed().subscribe(() => {
      this.reloadRepairerListForCustomer();
      this.selectedWorkshopId = this._inventoryService.getWorkshopId();
    });
  }


  onCloseClick(): void {
    this.dialogRef.close();
  }

  // save rebuild implment
  saveChanges(){
    if (this.savingChanges) {
      return;
  }

  let validation = this.validateData();
  this.savingChanges = true;
  if (validation == ErrorCode.VALIDATION_PASSED) {
    var params: RebuildImplementVM = new RebuildImplementVM();
        params.ImplementId = this.implementId;
        params.RebuilStartDate = this.eventDate;
        params.Status=this.statusID;
        params.WorkshopId=this.selectedWorkshopId;
        params.comment=this.comment==null?"":this.comment;
        params.cost=this.cost==null?0:this.cost;
        params.jobsiteID=this.jobsiteId;
        this._implementService.RebuildImplement(params).subscribe(response=>{
          if (response == false) {
            this.toastr.error(ErrorMessages.ERROR_SAVING);
        }
        else {
            //this.dialogRef.close();
            this.getCycleDetails();
            this.toastr.success("Sucessfully Saved")
        }
        })
      } else {
        console.log("erro")
        this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
       
    }
     this.savingChanges = false;
  }

  validateData(): number {
    var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
    
        if (this.implementId
            && this.eventDate
            && this.selectedWorkshopId>0) {
            if (this.cost < 0) {
                returnCode = ErrorCode.ERROR_NEGATIVE_COST;
            }
            else {
                returnCode = ErrorCode.VALIDATION_PASSED;
            }
        }
    
    return returnCode;
  }
  
}
